var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCookCurrent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52d853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27aa29"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66099",
    "data-name": "Group 66099",
    transform: "translate(-37.5 -316.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3012",
    "data-name": "Ellipse 3012",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(38 317)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66098",
    "data-name": "Group 66098",
    transform: "translate(-5.872 97.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66082",
    "data-name": "Group 66082",
    transform: "translate(49.615 225.615)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3013",
    "data-name": "Ellipse 3013",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(0.257 0.256)",
    fill: "rgba(255,255,255,0)",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66081",
    "data-name": "Group 66081",
    transform: "translate(53.681 230.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63861",
    "data-name": "Path 63861",
    d: "M2677.391-15183.686l1.306,1.416,3.753-3.307",
    transform: "translate(-2677.391 15185.576)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookCurrent);
export default __webpack_public_path__ + "static/media/cook-current.74ee56e2cc2b794478f5b16358d3ae7e.svg";
export { ForwardRef as ReactComponent };